import routes from "@/routes";

import { Table, Button, Flex } from "antd";

import CustomLink from "@/components/ui/CustomLink";

import TrashIcon from "@/icons/TrashIcon";
import PlusIcon from "@/icons/PlusIcon";
import PencilAltIcon from "@/icons/PencilAltIcon";
import ContextMenu from "@/components/containers/ContextMenu";

const Dot = () => (
  <span
    style={{
      display: "inline-block",
      width: 4,
      height: 4,
      borderRadius: "50%",
      backgroundColor: "#bbb",
      marginRight: 8,
      verticalAlign: "middle",
    }}
  />
);

// Таблица связанных ресурсов (используется в задаче)
// Содержит список с возможностью сортировки
// Тут можно настроить колонки
const AttachedResourcesTable = ({
  data,
  isAdmins,
  loading,
  onAddNested,
  onDeleteItem,
  onEditItem,
  readOnly = false,
}) => {
  const columns = [
    {
      title: "Ресурс",
      dataIndex: "name",
      key: "resource",
      ellipsis: {
        showTitle: false,
      },
      width: 350,
      render: (name, record) => {
        if (record.object_uuid) {
          const isObjectResource =
            record.type?.definition?.type === "object" ||
            record.definition?.type === "object";
          const isUnavailableObject =
            isObjectResource && record.canView === false;

          return isUnavailableObject ? (
            <span>
              {record.isNested && <Dot />}
              {record.isNested
                ? record.name + " / " + record.field_name
                : record.name}
            </span>
          ) : (
            <CustomLink
              to={
                isAdmins
                  ? routes.administration.objectDetail(
                      record.isNested
                        ? record.definition.uuid
                        : record.type.definition.uuid,
                      record.object_uuid,
                    )
                  : routes.objectDetail(
                      record.isNested
                        ? record.definition.uuid
                        : record.type.definition.uuid,
                      record.object_uuid,
                    )
              }
              color="#303030"
            >
              {record.isNested && <Dot />}
              {record.isNested
                ? record.name + " / " + record.field_name
                : record.name}
            </CustomLink>
          );
        }

        if (!record.object_uuid && !readOnly) {
          return (
            <Button
              type="link"
              icon={<PlusIcon />}
              onClick={() => onEditItem(record.original)}
              style={{ padding: 0, color: "#777777", alignSelf: "start" }}
            >
              Добавить ресурс
            </Button>
          );
        }

        return null;
      },
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      sorter: {
        compare: (a, b) => (a.quantity || 0) - (b.quantity || 0),
      },
      render: (quantity, record) => {
        if (!quantity) return null;
        const measure_unit =
          record.definition?.measure_unit ||
          record.type?.definition?.measure_unit;

        return measure_unit ? `${quantity} ${measure_unit}` : quantity;
      },
    },
    {
      title: "Тип ресурса",
      dataIndex: ["definition", "name"],
      key: "definition_type",
      width: 220,
      render: (_, record) => {
        if (!record.type || record.isNested) return null;

        return (
          <CustomLink
            to={
              isAdmins
                ? routes.administration.objectList(record.type?.definition.uuid)
                : routes.objectList(record.type?.definition.uuid)
            }
            color="#303030"
          >
            {record.type?.definition.name}
          </CustomLink>
        );
      },
    },
    {
      title: "Всего",
      dataIndex: "total",
      key: "total",
      width: 120,
      sorter: {
        compare: (a, b) => (a.type?.quantity || 0) - (b.type?.quantity || 0),
      },
      render: (_, record) => {
        if (record.isNested) return null;
        const measure_unit =
          record.definition?.measure_unit ||
          record.type?.definition?.measure_unit;

        return measure_unit
          ? `${record?.type?.quantity} ${measure_unit}`
          : record?.type?.quantity;
      },
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      ellipsis: {
        showTitle: false,
      },
      width: "250px",
      render: (_, record) => {
        return record.type?.comment || "";
      },
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      width: 140,
      ellipsis: {
        showTitle: false,
      },
      sorter: {
        compare: (a, b) => (a.type?.status || "").localeCompare(b.type?.status || ""),
      },
      render: (_, record) => {
        return record.type?.status || "";
      },
    },

    !readOnly ? {
      title: "",
      width: 60,
      align: "center",
      fixed: "right",
      key: "actions",
      render: (_, item) => {
        if (readOnly) return null;

        if (item.isNested) {
          return (
            <ContextMenu
              vertical
              items={[
                {
                  key: "delete",
                  label: (
                    <Flex align="center" gap={10}>
                      <TrashIcon style={{ fontSize: 16, color: "#bbb" }} />
                      Удалить
                    </Flex>
                  ),
                  onClick: () => onDeleteItem(item),
                },
              ]}
            />
          );
        }

        if (!item.object_uuid) {
          return (
            <ContextMenu
              vertical
              items={[
                {
                  key: "add",
                  label: (
                    <Flex align="center" gap={10}>
                      <PlusIcon style={{ fontSize: 16, color: "#bbb" }} />
                      Добавить ресурс
                    </Flex>
                  ),
                  onClick: () => onEditItem(item.original),
                },
                {
                  key: "divider",
                  type: "divider",
                },
                {
                  key: "delete",
                  label: (
                    <Flex align="center" gap={10}>
                      <TrashIcon style={{ fontSize: 16, color: "#bbb" }} />
                      Удалить тип ресурса
                    </Flex>
                  ),
                  onClick: () => onDeleteItem(item, true),
                },
              ]}
            />
          );
        }

        return (
          <ContextMenu
            vertical
            items={[
              {
                key: "add",
                label: (
                  <Flex align="center" gap={10}>
                    <PlusIcon style={{ fontSize: 16, color: "#bbb" }} />
                    Добавить ресурс
                  </Flex>
                ),
                onClick: () => onEditItem(item.original),
              },
              {
                key: "addNested",
                label: (
                  <Flex align="center" gap={10}>
                    <PlusIcon style={{ fontSize: 16, color: "#bbb" }} />
                    Добавить связанный ресурс
                  </Flex>
                ),
                onClick: () => {onAddNested({item: item.original, uuid: item.uuid})},
              },
              {
                key: "edit",
                label: (
                  <Flex align="center" gap={10}>
                    <PencilAltIcon style={{ fontSize: 16, color: "#bbb" }} />
                    Редактировать
                  </Flex>
                ),
                onClick: () => onEditItem(item.original),
              },
              {
                key: "divider",
                type: "divider",
              },
              {
                key: "delete",
                label: (
                  <Flex align="center" gap={10}>
                    <TrashIcon style={{ fontSize: 16, color: "#bbb" }} />
                    Удалить ресурс
                  </Flex>
                ),
                onClick: () => onDeleteItem(item),
              },
              {
                key: "delete-type",
                label: (
                  <Flex align="center" gap={10}>
                    <TrashIcon style={{ fontSize: 16, color: "#bbb" }} />
                    Удалить тип ресурса
                  </Flex>
                ),
                onClick: () => onDeleteItem(item, true),
              },
            ]}
          />
        );
      },
    } : null,
  ].filter(Boolean);

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={(record) =>
          `${record.object_uuid || "noobj"}_${record.field_uuid || "nofield"}_${record.type?.uuid || "notype"}`
        }
        loading={loading}
        pagination={false}
        expandable={{
          rowExpandable: (record) => {
            return !!record.children?.length;
          },
        }}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={{
          x: "100%",
        }}
      />
    </>
  );
};

export default AttachedResourcesTable;
